jQuery( function ( $ ) {
    'use strict';

    pma_show_hide_search_form();
    pma_back_to_top_link();
    pma_handle_menu_click();
    pma_handle_search_sidebar_toggle();
    pma_handle_faq_toggle();
    pma_form_field_toggle_handle();

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });

    jQuery('.marquee').marquee({
        duration: 20000,
        gap: 50,
        delayBeforeStart: 0,
        direction: 'left',
        duplicated: true
    });

    $('.sections .content').matchHeight();
    $('.sponsor-section .logo').matchHeight();

    let primary_with_dropdowns = jQuery('#main-nav .dropdown-toggle');

    primary_with_dropdowns.on('click', function(event) {
        jQuery(this).parent().toggleClass('dropdown-expanded');
        event.preventDefault();
    });

    // Allow smooth scroll
    $('.page-scroller').on('click', function (e) {
        e.preventDefault();
        var target = this.hash;
        var $target = $(target);
        $('html, body').animate({
            'scrollTop': $target.offset().top
        }, 1000, 'swing');
    });

});

function pma_handle_menu_click() {
    let body = jQuery( 'body' );
    let nav_wrapper = jQuery( '#main-nav-wrapper' );
    let menu_open = jQuery('#primary-menu-button');
    let menu_close = jQuery( '#close-primary-menu' );

    nav_wrapper.on( 'clickoutside', function (event) {
        if( nav_wrapper.hasClass('expanded') ) {
            nav_wrapper.removeClass('expanded');
        }
        if( body.hasClass('primary-nav-expanded') ) {
            body.removeClass('primary-nav-expanded');
        }

    });

    menu_open.on('click', function(event) {
        nav_wrapper.addClass( 'expanded' );
        body.addClass('primary-nav-expanded');
        event.stopPropagation();
    });

    menu_close.on( 'click', function( event ) {
        nav_wrapper.removeClass( 'expanded' );
        body.removeClass('primary-nav-expanded');
    } );
}
function pma_show_hide_search_form() {
    let search_icon = jQuery( '#mobile-search-toggle' );
    let search_form = jQuery( '#search-bar' );

    search_icon.on( 'click', function() {
        search_form.toggleClass( 'expanded' );
    } );

}
function pma_back_to_top_link() {
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 50) {
            jQuery('#back-to-top').fadeIn();
        } else {
            jQuery('#back-to-top').fadeOut();
        }
    });
    // scroll body to 0px on click
    jQuery('#back-to-top').on('click touchstart', function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 400);
        return false;
    });
}
function pma_handle_search_sidebar_toggle() {
    let search_sidebar_toggle = jQuery('#business-search-sidebar-toggle');
    let search_sidebar = jQuery('#business-search-sidebar');

    search_sidebar_toggle.on('click', function() {
        search_sidebar.toggleClass('expanded');
        
    });
}
function pma_handle_faq_toggle() {
    let faq_items = jQuery('.faq-item');

    faq_items.on('click', function() {
        jQuery(this).toggleClass('expanded');
    });
}
function pma_form_field_toggle_handle() {
    let form_label_toggle = jQuery('.toggle.af-field > .acf-label label');

    form_label_toggle.on('click', function() {
        console.log('test');
        jQuery(this).closest('.toggle').toggleClass('expanded');
    });
}